import { render, staticRenderFns } from "./co-single-post.vue?vue&type=template&id=18bb912d&"
import script from "./co-single-post.vue?vue&type=script&lang=ts&"
export * from "./co-single-post.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports